<div class="contract-list-container" fxLayout="column">
  <div fxLayout="row" style="margin-bottom: 15px">
    <button [class.spinner]="generatingDocument" [disabled]="!(userPermissions | async).contract.read || generatingDocument" mat-stroked-button [matMenuTriggerFor]="generate"><mat-icon>content_copy</mat-icon> Wygeneruj</button>
    <mat-menu #generate="matMenu">
      <button mat-menu-item (click)="generateAnnexApplication()">Aneks - zgłoszenie OFWCA</button>
      <button mat-menu-item (click)="generateApplication()">Zgłoszenie OFWCA</button>
    </mat-menu>
  </div>
  <table mat-table [dataSource]="contractOfwcaApplicationsDataSource">

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data wygenerowania </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="sendAt">
      <th mat-header-cell *matHeaderCellDef> Data wysłania </th>
      <td mat-cell *matCellDef="let element">
        {{element.sendAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="signedAt">
      <th mat-header-cell *matHeaderCellDef> Data podpisania </th>
      <td mat-cell *matCellDef="let element">
        {{element.signedAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element" class="status-select">
        <app-dict
          label="" [ngModel]="element.status.id" dictType="ofwca_application_status" [required]="true"
          [disabled]="!(userPermissions | async).registration.write || updateInProgress"
          (selectedDict)="formChanged(element, {status: $event.id, note: element.note})"
        ></app-dict>
      </td>
    </ng-container>

    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef> Uwagi</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field>
          <mat-label>Uwagi</mat-label>
          <textarea
            style="width: 300px"
            [disabled]="!(userPermissions | async).contract.write || updateInProgress"
            (focusout)="formChanged(element, {status: element.status.id, note: $any($event.target).value})" matInput [value]="element.note"></textarea>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-icon-button [matMenuTriggerFor]="menu"
        ><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button mat-menu-item (click)="showOfwcaList(element)">Lista OFWCA</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns; let element"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]"></mat-paginator>
</div>
